var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tree-box" }, [
    _c(
      "div",
      { staticClass: "el-card__header clearfix" },
      [
        _c("el-input", {
          attrs: {
            size: "small",
            clearable: "",
            placeholder: "搜索部门",
            "prefix-icon": "el-icon-search",
          },
          model: {
            value: _vm.filterText,
            callback: function ($$v) {
              _vm.filterText = $$v
            },
            expression: "filterText",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { directives: [{ name: "height", rawName: "v-height" }] },
      [
        _c(
          "el-scrollbar",
          { staticStyle: { height: "100%" } },
          [
            _c("el-tree", {
              ref: "tree",
              attrs: {
                data: _vm.treeData,
                props: _vm.defaultProps,
                "highlight-current": true,
                "filter-node-method": _vm.filterNode,
                "default-expanded-keys": _vm.defaultFrame,
                "expand-on-click-node": false,
                "node-key": "value",
              },
              on: { "node-click": _vm.handleClick },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var node = ref.node
                    var data = ref.data
                    return _c("div", { staticClass: "custom-tree-node" }, [
                      _c("span", { staticClass: "flex-box" }, [
                        _c("i", {
                          staticClass: "icon iconfont tree-icon iconwenjianjia",
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(node.label) +
                            "\n            "
                        ),
                        data.user_count && _vm.isShowUserCount
                          ? _c("span", [
                              _vm._v("(" + _vm._s(data.user_count) + ")"),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }